import { useScrollReveal } from '@/hooks/useScrollReveal';

const topics = [
  { label: '明星正能量', hot: true, count: '2.3k', desc: '娱乐圈暖心善举' },
  { label: '社会暖心', hot: true, count: '1.8k', desc: '平凡人的不凡事' },
  { label: '职场励志', hot: false, count: '956', desc: '打工人的逆袭' },
  { label: '科技趣闻', hot: false, count: '1.2k', desc: '科技圈正能量' },
  { label: '体育精神', hot: true, count: '1.5k', desc: '赛场内外力量' },
  { label: '校园正能量', hot: false, count: '873', desc: '青春励志故事' },
  { label: '公益行动', hot: false, count: '1.1k', desc: '善意汇聚力量' },
  { label: '家庭温情', hot: true, count: '2.1k', desc: '亲情爱情友情' },
  { label: '创业故事', hot: false, count: '768', desc: '创业者的正能量' },
  { label: '文化传承', hot: false, count: '634', desc: '传统文化之美' },
  { label: '国际视野', hot: false, count: '512', desc: '全球温暖故事' },
];

export default function TopicsSection() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="topics" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/60 px-3 py-1 rounded-full mb-3">
            话题探索
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选十一个正能量话题领域，发现属于你的关注方向，每个话题背后都有温暖故事
          </p>
        </div>

        <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {topics.map((topic, i) => (
            <a
              key={topic.label}
              href="#topics"
              className="group bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-300 hover:bg-background-50 transition-all cursor-pointer text-center"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <div className="flex items-center justify-center gap-1.5 mb-2">
                {topic.hot && (
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
                )}
                <span className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {topic.label}
                </span>
              </div>
              <p className="text-xs text-foreground-500 mb-2 md:mb-3 line-clamp-1">{topic.desc}</p>
              <span className="inline-block text-xs text-foreground-400 bg-background-100 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors px-2.5 py-1 rounded-full">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}